import React from 'react';
import PropTypes from 'prop-types';
import { LozengeSmall } from 'Packages/FacetDesign/Components';

export const PillarLozenge = ({ resource: pillarResource, featured }) => {
  const isOverdue = pillarResource.isTruthy('overdue');
  let color = featured ? 'primary' : 'subtle';
  if (isOverdue) {
    color = 'error';
  }
  return (
    <LozengeSmall
      color={color}
      value={pillarResource.selectedOptionPrompt('pillar').substring(0, 33)}
    />
  );
};

PillarLozenge.defaultProps = {
  featured: false,
};

PillarLozenge.propTypes = {
  resource: PropTypes.object.isRequired,
  featured: PropTypes.bool,
};
